document.addEventListener('DOMContentLoaded', () => {
  const bundleCards = document.querySelectorAll('.bundle-card');
  const dropdowns = document.querySelectorAll('.bundle-row-dropdown');
  const mobileDropdown = document.querySelector('.bundle-mobile-dropdown');
  const bundleVariants = document.querySelectorAll('.bundle-info.variant-bundle');
  let currentRowId = null; // Variable to track the row of the currently opened dropdown
  let mobileDropdownClose;
  let openBundleCard = null;

  if (mobileDropdown) {
    mobileDropdownClose = document.querySelector(".bundle-mobile-dropdown-close");
  }

  // Function to determine if the screen is mobile
  function isMobile() {
    return window.innerWidth <= 767; // Adjust the width as needed for your design
  }

  function setBundleCardOpenState(activeCard) {
    bundleCards.forEach((card) => {
      const isOpen = card === activeCard;
      card.classList.toggle('is-open', isOpen);
      card.setAttribute('aria-expanded', String(isOpen));
    });
    openBundleCard = activeCard || null;
  }

  function clearBundleCardOpenState() {
    setBundleCardOpenState(null);
  }

  function openBundleCardPreview(bundleCard) {
      // Get product data
      const productId = bundleCard.getAttribute('data-product-id');
      const productTitle = bundleCard.getAttribute('data-product-title');
      const productPrice = bundleCard.getAttribute('data-product-price');
      const productDescription = bundleCard.getAttribute('data-product-description');
      const productEmbed = bundleCard.getAttribute('data-product-embed');
      const productVideo = bundleCard.getAttribute('data-product-video');
      const productImg = bundleCard.getAttribute('data-product-image');

      const mediaType = bundleCard.getAttribute('data-media-type');    // Find the parent bundleGrid of the clicked card
      const bundleGrid = bundleCard.closest('.bundle-grid');
      if (!bundleGrid) return;

      // Get only the cards inside this bundleGrid
      const gridCards = bundleGrid.querySelectorAll('.bundle-card');

      // Calculate row index relative to this grid
      const rowId = Math.floor([...gridCards].indexOf(bundleCard) / 4);

      // Find the dropdown inside the same bundleGrid
      const dropdown = bundleGrid.querySelector(`.bundle-row-dropdown[data-row-id="${rowId}"]`);
      
      if (!dropdown) return;

      if (dropdown){
        const dropdownMedia = dropdown.querySelector(".dropdown-product-media");
        const dropdownContent = dropdown.querySelector('.dropdown-product-details');
        const mobileDropdownMedia = mobileDropdown.querySelector(".mobile-dropdown-product-media");
        const mobileDropdownContent = mobileDropdown.querySelector('.mobile-dropdown-product-details');
        const dropdownClose = dropdown.querySelector(".bundle-dropdown-close");

        // Hide all other dropdowns
        dropdowns.forEach((currentDropdown) => {
          if (currentDropdown !== dropdown) {
            currentDropdown.classList.remove('active');
          }
          
          let currentMedia = currentDropdown.querySelector(".dropdown-product-media");
          if (currentMedia) {
            console.log('has media');
            currentMedia.innerHTML = '';
          }
        });

        if (dropdownClose && !dropdownClose.dataset.bundleCloseBound) {
          dropdownClose.dataset.bundleCloseBound = 'true';
          dropdownClose.addEventListener('click', function(event) {
            event.stopPropagation();
            dropdown.classList.remove('active');
            if (dropdownMedia) dropdownMedia.innerHTML = '';
            clearBundleCardOpenState();
          });
        }

        // Update Dropdown media
        if (productEmbed) {
          dropdownMedia.innerHTML = `${productEmbed}`;
          mobileDropdownMedia.innerHTML = `${productEmbed}`;
        } else if (mediaType == 'image') {
          if (productImg) {
            dropdownMedia.innerHTML = `<img src="${productImg}">`;
            mobileDropdownMedia.innerHTML = `<img src="${productImg}">`;
          }
        } else if (mediaType == 'external_video') {
          if (productVideo) {
            dropdownMedia.innerHTML = `<iframe src="${productVideo}" frameborder="0" allowfullscreen></iframe>`;
            mobileDropdownMedia.innerHTML = `<iframe src="${productVideo}" frameborder="0" allowfullscreen></iframe>`;
          }
        }

        // Update dropdown content
        dropdownContent.innerHTML = `
          <h4>${productTitle}</h4>
          <p><strong>Price:</strong> ${productPrice}</p>
          <div class="bundle-product-description">${productDescription}</div>
        `;

        mobileDropdownContent.innerHTML = `
          <h4>${productTitle}</h4>
          <p><strong>Price:</strong> ${productPrice}</p>
          <div class="bundle-product-description">${productDescription}</div>
        `;

        // Show the correct desktop dropdown
        dropdown.classList.add('active');
        setBundleCardOpenState(bundleCard);

        // If on mobile, show the single Dropdown
        if (isMobile()) {
          mobileDropdown.classList.add('active');
        }

        if (mobileDropdownClose && !mobileDropdownClose.dataset.bundleCloseBound) {
          mobileDropdownClose.dataset.bundleCloseBound = 'true';
          mobileDropdownClose.addEventListener('click', function(event) {
            event.stopPropagation();
            mobileDropdown.classList.remove('active');
            clearBundleCardOpenState();
          });
        }
      }
  }

  bundleCards.forEach((bundleCard) => {
    bundleCard.addEventListener('click', () => {
      openBundleCardPreview(bundleCard);
    });

    bundleCard.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      openBundleCardPreview(bundleCard);
    });
  });

  // Close mobile dropdown when clicking outside (bound once)
  document.addEventListener('click', function(event) {
    if (!mobileDropdown) return;
    if (!mobileDropdown.contains(event.target) && !event.target.closest('.bundle-card')) {
      if (mobileDropdown.classList.contains('active')) {
        mobileDropdown.classList.remove('active');
        clearBundleCardOpenState();
      }
    }
  });

  window.addEventListener('resize', function() {
    if (!mobileDropdown) return;
    if (!isMobile()) {
      // Hide the Dropdown if resizing to desktop
      mobileDropdown.classList.remove('active');
    }
  });

  if (bundleVariants){
    const variantSelectorForm = document.querySelector(".product-form__input");
    if (!variantSelectorForm) return;

    const variantSelectorRadios = variantSelectorForm.querySelectorAll("input[type=radio]");

    variantSelectorRadios.forEach((radio, index) => {
      radio.addEventListener("click", () => {
         bundleVariants.forEach((variant, index) => {
            if (variant.dataset.variant == radio.value){
              variant.style.display = "block";
              const productInfo = document.querySelector('product-info');
              if (productInfo) {
                if (variant.dataset.variantId) {
                  productInfo.dataset.variantId = variant.dataset.variantId;
                }
                if (typeof variant.dataset.bundleContentIds === 'string') {
                  productInfo.dataset.bundleContentIds = variant.dataset.bundleContentIds;
                }
              }
            } else {
              variant.style.display = "none";
            }
         });
         clearBundleCardOpenState();
         if (typeof window.applyStorefrontOwnership === 'function') {
           window.applyStorefrontOwnership();
         }
      });
    });
  }
});
